/**
 * RetarderFieldButton - Retarder field button using existing hooks
 */

import {useRetarder} from '@hconnect/tuc-processes/fields/retarder/useRetarder'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {getTranslatedErrorMessage} from '../../../../../orderIntake'
import {FieldButton} from '../../FieldButton'

interface RetarderFieldButtonProps {
  onClick: () => void
  requiresApproval?: boolean
  isReadOnly?: boolean
  isChanged?: boolean
}

export const RetarderFieldButton: React.FC<RetarderFieldButtonProps> = ({
  onClick,
  requiresApproval = false,
  isReadOnly = false,
  isChanged = false
}) => {
  const {t} = useTranslation()
  const {retarder, error} = useRetarder()

  // Following useRmcOrderEditLogic pattern exactly
  const displayValue =
    retarder?.retarder !== undefined && retarder?.retarder !== null
      ? `${retarder.retarder}${retarder.retarderUom ? ` ${retarder.retarderUom}` : ''}`
      : null

  return (
    <FieldButton
      label={t('orderIntake.rmc.orderManagement.editSteps.labels.retarder', 'Retarder')}
      value={displayValue}
      onClick={onClick}
      requiresApproval={requiresApproval}
      isReadOnly={isReadOnly}
      isChanged={isChanged}
      error={getTranslatedErrorMessage(error, t)}
    />
  )
}
